import { gql } from '@apollo/client';

export const DirectoryFragment = gql`
  fragment Directory on Directory {
    identifier
    isFederated
    label
  }
`;